var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ImageGrid"}},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',[_c('div',{staticClass:"img"},[_c('img',{staticClass:"image",attrs:{"src":item.image}}),_c('p',{staticClass:"description"},[_vm._v(_vm._s(item.description))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }